// GET ROOM IMAGES
export const GET_ROOM_IMAGES = 'GET_ROOM_IMAGES';
export const GET_ROOM_IMAGES_SUCCESS = 'GET_ROOM_IMAGES_SUCCESS';
export const GET_ROOM_IMAGES_FAILED = 'GET_ROOM_IMAGES_FAILED';

// ADD IMAGES TO ROOMS
export const ADD_IMAGES_TO_ROOMS = 'ADD_IMAGES_TO_ROOMS';
export const ADD_IMAGES_TO_ROOMS_SUCCESS = 'ADD_IMAGES_TO_ROOMS_SUCCESS';
export const ADD_IMAGES_TO_ROOMS_FAILED = 'ADD_IMAGES_TO_ROOMS_FAILED';

// DELETE ROOM IMAGES
export const DELETE_ROOM_IMAGES = 'DELETE_ROOM_IMAGES';
export const DELETE_ROOM_IMAGES_SUCCESS = 'DELETE_ROOM_IMAGES_SUCCESS';
export const DELETE_ROOM_IMAGES_FAILED = 'DELETE_ROOM_IMAGES_FAILED';

// CHANGE POSITION ROOM IMAGES
export const CHANGE_POSITION_ROOM_IMAGES = 'CHANGE_POSITION_ROOM_IMAGES';
export const CHANGE_POSITION_ROOM_IMAGES_SUCCESS = 'CHANGE_POSITION_ROOM_IMAGES_SUCCESS';
export const CHANGE_POSITION_ROOM_IMAGES_FAILED = 'CHANGE_POSITION_ROOM_IMAGES_FAILED';

// GET ROOMS OF PLACE
export const GET_ROOMS_OF_PLACE = 'GET_ROOMS_OF_PLACE';
export const GET_ROOMS_OF_PLACE_SUCCESS = 'GET_ROOMS_OF_PLACE_SUCCESS';
export const GET_ROOMS_OF_PLACE_FAILED = 'GET_ROOMS_OF_PLACE_FAILED';

// GET ROOM DETAIL OF PLACE
export const GET_ROOM_DETAIL_OF_PLACE = 'GET_ROOM_DETAIL_OF_PLACE';
export const GET_ROOM_DETAIL_OF_PLACE_SUCCESS = 'GET_ROOM_DETAIL_OF_PLACE_SUCCESS';
export const GET_ROOM_DETAIL_OF_PLACE_FAILED = 'GET_ROOM_DETAIL_OF_PLACE_FAILED';

// UPDATE ROOM IMAGES
export const UPDATE_ROOM_IMAGES = 'UPDATE_ROOM_IMAGES';

export const RESET_ROOM_IMAGES = 'RESET_ROOM_IMAGES';

// CREATE NEW ROOM
export const CREATE_NEW_ROOM = 'CREATE_NEW_ROOM';
export const CREATE_NEW_ROOM_SUCCESS = 'CREATE_NEW_ROOM_SUCCESS';
export const CREATE_NEW_ROOM_FAILED = 'CREATE_NEW_ROOM_FAILED';

// UPDATE ROOM OF PLACE
export const UPDATE_ROOM_OF_PLACE = 'UPDATE_ROOM_OF_PLACE';
export const UPDATE_ROOM_OF_PLACE_SUCCESS = 'UPDATE_ROOM_OF_PLACE_SUCCESS';
export const UPDATE_ROOM_OF_PLACE_FAILED = 'UPDATE_ROOM_OF_PLACE_FAILED';

// DELETE ROOM OF PLACE
export const DELETE_ROOM_OF_PLACE = 'DELETE_ROOM_OF_PLACE';
export const DELETE_ROOM_OF_PLACE_SUCCESS = 'DELETE_ROOM_OF_PLACE_SUCCESS';
export const DELETE_ROOM_OF_PLACE_FAILED = 'DELETE_ROOM_OF_PLACE_FAILED';

// GET ROOM NAMES SETTING
export const GET_ROOM_NAMES = 'GET_ROOM_NAMES';
export const GET_ROOM_NAMES_SUCCESS = 'GET_ROOM_NAMES_SUCCESS';
export const GET_ROOM_NAMES_FAILED = 'GET_ROOM_NAMES_FAILED';

// SET ROOM PREVIEW IMAGE
export const SET_ROOM_PREVIEW_IMAGE = 'SET_ROOM_PREVIEW_IMAGE';
export const SET_ROOM_PREVIEW_IMAGE_SUCCESS = 'SET_ROOM_PREVIEW_IMAGE_SUCCESS';
export const SET_ROOM_PREVIEW_IMAGE_FAILED = 'SET_ROOM_PREVIEW_IMAGE_FAILED';

// UPDATE ROOM VIDEO
export const UPDATE_ROOM_VIDEO = 'UPDATE_ROOM_VIDEO';
export const UPDATE_ROOM_VIDEO_SUCCESS = 'UPDATE_ROOM_VIDEO_SUCCESS';
export const UPDATE_ROOM_VIDEO_FAILED = 'UPDATE_ROOM_VIDEO_FAILED';

// DELETE ROOM VIDEO
export const DELETE_ROOM_VIDEO = 'DELETE_ROOM_VIDEO';
export const DELETE_ROOM_VIDEO_SUCCESS = 'DELETE_ROOM_VIDEO_SUCCESS';
export const DELETE_ROOM_VIDEO_FAILED = 'DELETE_ROOM_VIDEO_FAILED';
